import { getI18n, useTranslation } from "react-i18next";
import { validShellDescriptor } from "../../../../src/lib/i18n/shellFeedback";
import { sharedFeedbackValue, sharedFeedbackText } from "./sharedFeedbackPresentation";
import source from "./locales/en/shellFeedback";
export function useShellFeedbackLanguage(): void { useTranslation("shellFeedback"); }
export function shellFeedbackText(fallback: string | undefined, descriptor: unknown): string | undefined {
  if (fallback === undefined) return fallback;
  const shared = sharedFeedbackValue(fallback, descriptor); if (shared) return sharedFeedbackText(shared);
  if (!validShellDescriptor(descriptor)) return fallback;
  const engine = getI18n(); const locale = engine?.resolvedLanguage ?? engine?.language ?? "en";
  const code = descriptor.code as keyof typeof source;
  const catalog: Record<string, unknown> | undefined = engine?.isInitialized ? engine.getResourceBundle(locale, "shellFeedback") : undefined;
  const template = catalog && Object.prototype.hasOwnProperty.call(catalog, code) && typeof catalog[code] === "string" ? catalog[code] : source[code];
  return template.replace(/{{(\w+)}}/g, (match, name: string) => Object.prototype.hasOwnProperty.call(descriptor.params, name)
    ? typeof descriptor.params[name] === "number" ? new Intl.NumberFormat(locale, { useGrouping: false }).format(descriptor.params[name]) : String(descriptor.params[name]) : match);
}
